import { CommonAPI } from "@/services/api";
import AuthApi from "@/services/api/auth-api";
import LocalStorage from "@/services/localStorage";

const state = {
  access_token: LocalStorage.get("token"),
  profile: {},
  device_info: {},
};


const getters = {
  isLoggedIn(state: { access_token: string }) {
    return !!state.access_token;
  },
  profile(state: { profile: any }) {
    return state.profile;
  },
};

const actions = {
  LOGIN(context: { commit: any }, payload: any) {
    return AuthApi.oauthTokenLogin(payload)
      .then((response) => {
        context.commit("SET_TOKEN", response.data);

        return CommonAPI.getAccountInfo()
          .then((res) => {
            context.commit("SET_DEVICE_INFO", res);
          })
          .catch((error) => {
            throw error.response;
          });

        return response.data;
      })
      .catch((error) => {
        throw error.response;
      });
  },

  LOGIN_AUDRA_DEVICE_SELECTION(context: { commit: any }, payload: any) {
    return AuthApi.oauthTokenLogin_audra_device_selection(payload)
      .then((response) => {
        context.commit("SET_TOKEN", response.data);
        
        const accountId = LocalStorage.get('accountId');
  
        return CommonAPI.getAccountInfoForCache(accountId)
          .then((res) => {
            context.commit("SET_DEVICE_INFO_CACHE", res);
            return response.data;
          })
          .catch((error) => {
            throw error.response || error;
          });
      })
      .catch((error) => {
        throw error.response || error;
      });
  },

  LOGIN_AUDRA_DEVICE_FIRSTTIME(context: { commit: any }, payload: any) {
    return AuthApi.oauthTokenLogin_audra_firsttime(payload)
      .then((response) => {
        if (response.data && response.data.hasOwnProperty('credentials')) {
          return 'otp_page';
        }

        context.commit("SET_TOKEN", response.data);

        const accountId = LocalStorage.get('accountId');

        return CommonAPI.getAccountInfoForCache(accountId)
          .then((res) => {
            context.commit("SET_DEVICE_INFO_CACHE", res);
            return 'success';
          })
          .catch((error) => {
            throw error.response || error;
          });
      })
      .catch((error) => {
        throw error.response || error;
      });
  },


  LOGIN_AUDRA_DEVICE_FIRSTTIME_OTP_CONFIRM(context: { commit: any }, payload: any) {
    return AuthApi.oauthTokenLogin_audra_otp_confirm(payload)
      .then((response) => {
        context.commit("SET_TOKEN", response.data);
        const accountId = LocalStorage.get('accountId');

        return CommonAPI.getAccountInfoForCache(accountId)
          .then((res) => {
            context.commit("SET_DEVICE_INFO_CACHE", res);
          })
          .catch((error) => {
            throw error.response;
          });
      })
      .catch((error) => {
        throw error.response;
      });
  },

  FETCH_PROFILE(context: { commit: (arg0: string, arg1: any) => void }) {
    AuthApi.fetchProfile().then((response) => {
      context.commit("SET_PROFILE", response);
    });
  },

  LOGOUT(state: any, commit: any) {
    //  LocalStorage.set('token', '')
    if (localStorage.getItem("authenticate") === null || LocalStorage.get('authenticate') == false) {
      LocalStorage.set("authenticate", "false");
    } else {
      CommonAPI.logout()
        .then(() => {
          LocalStorage.set("authenticate", "false");
        })
        .catch((error:any) => {
          console.log(error);
        });
    }
  },
};

const mutations = {
  SET_TOKEN(state: { access_token: string }, response: any) {
    LocalStorage.set("token", response.access_token);
    LocalStorage.set("refresh_token", response.refresh_token);
    LocalStorage.set("authenticate", "true");
  },

  SET_PROFILE(state: { profile: any }, payload: any) {
    state.profile = payload;
  },

  SET_DEVICE_INFO(state: { device_info: any }, deviceInfo: any) {
    if (deviceInfo.length) {
      LocalStorage.set("deviceType", deviceInfo[0].device_type);
      LocalStorage.set("version", deviceInfo[0].version);
      LocalStorage.set("accountId", deviceInfo[0].id);
      LocalStorage.set("baseAPIURL", "http://127.0.0.1:8082");
    }
  },

  SET_DEVICE_INFO_CACHE(state: { device_info: any }, deviceInfo: any) {
    if (deviceInfo) {
      LocalStorage.set("version", deviceInfo.version);
      LocalStorage.set("latestVersion", deviceInfo.version_no);
      LocalStorage.set("mac", deviceInfo.AP_WI_mac);
      LocalStorage.set("ipAddr", deviceInfo.pip);
      LocalStorage.set("userId", deviceInfo.userId);
      LocalStorage.set("userLicense", deviceInfo.license_user);
      LocalStorage.set("deviceType", deviceInfo.device_type);
      LocalStorage.set("organizationId", deviceInfo.organization_ref_id);
      LocalStorage.set("releaseDate", deviceInfo.release_date);
    }
  },  
};

export default {
  namespace: true,
  state,
  actions,
  mutations,
  getters,
};